import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';

import { map, withLatestFrom, bufferTime, filter } from 'rxjs/operators';
import { Actions } from '../../actions';
import { GetAssetStatus } from '../action-creators';
import { CreateTrackSuccess } from '../../tracks/action-creators';
import { CREATE_TRACK_SUCCESS } from '../../tracks/actions';
import AppState from '../../state';

export const getStatusAfterCreateTrackEpic = (
  action$: Observable<Actions>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Actions, CreateTrackSuccess>(CREATE_TRACK_SUCCESS),
    bufferTime(2000),
    filter((actions) => actions.length > 0),
    withLatestFrom(state$),
    map(([actions, state]) => {
      const category = 'audio';
      const ids = Object.values(state.tracks)
        .filter((t) => t.status !== 'valid' && t.id)
        .map((t) => t.id);

      const newIds = actions.map((action) => action.track.id);

      return new GetAssetStatus(category, ids.concat(newIds) as string[]);
    })
  );
